import React, { useState, useEffect } from "react";
import {
  API_TOKEN_NAME,
  IMAGE_URL,
  SEARCH_SELECTED_DOC_ID,
  SEARCH_SELECTED_DOC_NAME,
  USER_ID,
  USER_LOCAL_ID,
} from "../../../constants";
import { scAxiosAdmin } from "../../..";
import "react-toastify/dist/ReactToastify.css";
import banner_img from "../../../images/banner-profile.jpg";
import Slider from "react-slick";
import $ from "jquery";
import { Helmet } from "react-helmet";
import SEO from "../../Seo";
import BookAppointmentPopup from "../BookAppointmentPopup";
import { FaCalendarAlt, FaPhoneAlt } from "react-icons/fa";
import BookAppointmentParticularDoctorPopUp from "../BookAppointmentParticularDoctorPopUp";
import ConfirmAppointmentAndRequestAppointmentParticularDoctorWithScheduleSelected from "../ConfirmAppointmentAndRequestAppointmentParticularDoctorWithScheduleSelected";
import { isMobile } from "react-device-detect";

const getSingleDoctorData = (id) => {
  return new Promise((resolve, reject) => {
    const req = scAxiosAdmin.request(
      "/doctors/getsingledoctorprofile_front/" + id,
      {
        method: "get",
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.getItem(API_TOKEN_NAME),
        },
      }
    );
    req.then((res) => resolve(res)).catch((err) => reject(err));
  });
};

const getDoctorPublicationsData = (id) => {
  return new Promise((resolve, reject) => {
    const req = scAxiosAdmin.request(
      "/publications/getdoctorpublications/" + id,
      {
        method: "get",
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.getItem(API_TOKEN_NAME),
        },
      }
    );
    req.then((res) => resolve(res.data)).catch((err) => reject(err));
  });
};

const getDoctorTestimonials = (data) => {
  return new Promise((resolve, reject) => {
    const req = scAxiosAdmin.request("/testimonials", {
      method: "get",
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + localStorage.getItem(API_TOKEN_NAME),
      },
    });
    req.then((res) => resolve(res)).catch((err) => reject(err));
  });
};

const getSingleDoctorScheduleData = (data) => {
  return new Promise((resolve, reject) => {
    const req = scAxiosAdmin.request("/doctors", {
      method: "get",
      headers: {
        Accept: "application/json",
      },
      params: {
        ...data,
      },
    });
    req.then((res) => resolve(res)).catch((err) => reject(err));
  });
};

const DoctorProfile = ({ currentDocId }) => {
  const [doctorData, setDoctorData] = useState(null);
  const [doctorID, setDoctorID] = useState("");
  const [doctorName, setDoctorName] = useState("");
  const [doctorProfile, setDoctorProfile] = useState("");
  const [doctorDegree, setDoctorDegree] = useState("");
  const [doctorDesignation, setDoctorDesignation] = useState("");
  const [doctorFees, setDoctorFees] = useState("");
  const [doctorPublications, setDoctorPublications] = useState([]);
  const [doctorEdu, setDoctorEdu] = useState("");
  const [doctorExp, setDoctorExp] = useState("");
  const [doctorTable, setDoctorTable] = useState("");
  const [docProfessionalSkills, setDocProfessionalSkills] = useState("");
  const [docMemberships, setDocMemberships] = useState("");
  const [docAwards, setDocAwards] = useState("");
  const [docKeyResearchExperience, setDocKeyResearchExperience] = useState("");
  const [docKeyPublications, setDocKeyPublications] = useState("");
  const [docKeyScientificPresentations, setDocKeyScientificPresentations] =
    useState("");
  const [loading, setLoading] = useState(true);
  const [testimonials, setTestimonials] = useState([]);
  const [doctorSchedulesTime, setDoctorSchedulesTime] = useState({});
  const [descriptions, setDescriptions] = useState([]);
  const [scheduleReqData, setScheduleReqData] = useState({
    DoctorId: "",
    PreferredDate: "",
    doctorData: null,
    selectedSchedule: "",
  });

  const refreshGetDoctorData = async (id) => {
    try {
      const res = await getSingleDoctorData(id);
      if (res.status === 200) {
        const records = res.data.data;
        setDoctorName(records.doctor_name || "");
        setDoctorDesignation(records.designation || "");
        setDoctorProfile(records.doctor_profile || "");
        setDoctorDegree(records.degree || "");
        setDoctorFees(records.doctor_fees || "");
        setDoctorEdu(records.doctor_edu || "");
        setDoctorTable(JSON.parse(records.doctor_table) || "");
        setDoctorExp(records.doctor_exp || "");
        setDocProfessionalSkills(records.doc_professional_skills || "");
        setDocMemberships(records.doc_memberships || "");
        setDocAwards(records.doc_awards || "");
        setDocKeyResearchExperience(records.doc_key_research_experience || "");
        setDocKeyPublications(records.doc_key_publications || "");
        setDocKeyScientificPresentations(
          records.doc_key_scientific_presentations || ""
        );
        setDoctorID(records.id || "");
        setDescriptions(JSON.parse(records.description_list) || []);
        setDoctorSchedulesTime(records.Schedule[0] || {});
        setDoctorData(records);
        setScheduleReqData({
          DoctorId: records.id,
          PreferredDate: new Date().toISOString().split("T")[0],
          doctorData: records,
        });
      } else {
        // Reset state if no data
        setDoctorName("");
        setDoctorDesignation("");
        setDoctorProfile("");
        setDoctorDegree("");
        setDoctorFees("");
        setDoctorEdu("");
        setDoctorExp("");
        setDocProfessionalSkills("");
        setDocMemberships("");
        setDocAwards("");
        setDocKeyResearchExperience("");
        setDocKeyPublications("");
        setDocKeyScientificPresentations("");
        setDescriptions([]);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const refreshGetDoctorTestimonials = async (doctor_id) => {
    try {
      const res = await getDoctorTestimonials({ doctor_id });
      if (res.status === 200) {
        const records = res.data;

        const filteredTestimonial = records.filter(
          (testimonial) =>
            testimonial.doctor_id &&
            parseInt(testimonial.doctor_id) === doctorID
        );
        // console.log("your log output", filteredTestimonial);
        setTestimonials(filteredTestimonial);
      } else {
        setTestimonials([]);
      }
    } catch (err) {
      console.log(err);
      setTestimonials([]);
    } finally {
      setLoading(false);
    }
  };

  const refreshGetDoctorPublicationsData = async (id) => {
    try {
      const res = await getDoctorPublicationsData(id);
      if (res.status === true) {
        setDoctorPublications(res.data);
      } else {
        setDoctorPublications([]);
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    const doctor_id = currentDocId.split("~").pop();
    refreshGetDoctorData(doctor_id);
    refreshGetDoctorPublicationsData(doctor_id);
    refreshGetDoctorTestimonials(doctor_id);
  }, [currentDocId, doctorID]);

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
  };

  return (
    <div>
      <SEO
        title={`${doctorName} | Best Hospital in Bangladesh | United Hospital`}
        description="United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
        pathSlug="/"
        keywords="Doctor, singledoctor"
      />
      <Helmet>
        <meta
          name="description"
          content="United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
        />
        {/* Add other meta tags here */}
      </Helmet>
      <div id="giveMargin" style={{ backgroundColor: "#ffffff" }}>
        <section className="banner-hero">
          <img src={banner_img} alt="banner-profile" className="w-100" />
        </section>
        <section className="prof-dr pb-3">
          <div className="container">
            <div
              className="box-of-about border-part px-0 py-5 border-0 rounded-3"
              style={{
                backgroundPosition: "center",
                backgroundSize: "cover",
                backgroundColor: "#fff",
                borderRadius: "20px",
              }}
            >
              <div className="row">
                <div className="col-lg-5 col-md-12">
                  <div className="text-profile d-flex gap-4">
                    <div className="d-flex justify-content-center justify-content-md-start">
                      {doctorProfile ? (
                        <img
                          src={`${IMAGE_URL}DoctorProfileImg/${doctorProfile}`}
                          alt="doc"
                          className="img-doc border-0 shadow"
                        />
                      ) : (
                        <img
                          src="https://static.vecteezy.com/system/resources/thumbnails/003/337/584/small/default-avatar-photo-placeholder-profile-icon-vector.jpg"
                          alt="doc"
                          className="img-doc border-0 shadow"
                        />
                      )}
                    </div>
                    <div className="d-flex flex-column mt-2">
                      <h2 title={doctorName}>{doctorName}</h2>
                      <p>{doctorDegree}</p>
                      <p>{doctorDesignation}</p>
                    </div>
                    {/* <h3 className="mt-4">Profile</h3> */}
                  </div>
                </div>

                <div className="col-lg-7 col-md-12">
                  <div className="text-profile" id="mobile-part">
                    <h3>Availability</h3>
                    <div
                      className="row"
                      id="tab-mob"
                      style={{ justifyContent: "left" }}
                    >
                      {doctorSchedulesTime
                        ? (() => {
                            let maxHeight = 100;
                            const validDays = [
                              "Saturday",
                              "Sunday",
                              "Monday",
                              "Tuesday",
                              "Wednesday",
                              "Thursday",
                              "Friday",
                            ];
                            const elements = Object.entries(doctorSchedulesTime)
                              .map(([day, time]) => {
                                if (!validDays.includes(day)) return null; // Ignore invalid days
                                return [day, time];
                              })
                              .filter(Boolean) // Remove null values
                              .sort(
                                ([day1], [day2]) =>
                                  [
                                    "Saturday",
                                    "Sunday",
                                    "Monday",
                                    "Tuesday",
                                    "Wednesday",
                                    "Thursday",
                                    "Friday",
                                  ].indexOf(day1) -
                                  [
                                    "Saturday",
                                    "Sunday",
                                    "Monday",
                                    "Tuesday",
                                    "Wednesday",
                                    "Thursday",
                                    "Friday",
                                  ].indexOf(day2)
                              )
                              .map(([day, time]) => {
                                if (!time) return null; // Skip empty time slots

                                const timeSlots = time
                                  .split(",")
                                  .map((slot, index) => (
                                    <li key={index}>{slot}</li>
                                  ));

                                return (
                                  <div
                                    key={day}
                                    className="doctor_schedule_section col-3 p-1"
                                    ref={(el) => {
                                      if (el) {
                                        const height =
                                          el.getBoundingClientRect().height;
                                        maxHeight = Math.max(maxHeight, height);
                                      }
                                    }}
                                  >
                                    <div>
                                      {/* <div
                                        className="avability_time"
                                        id="doctor_avability_time_1"
                                        name="doctor_avability_time"
                                        value={time}
                                        avabilityDay={day.toLowerCase()}
                                      /> */}
                                      <div className="table table-sst">
                                        <ul>
                                          <li>{day}</li>
                                          {timeSlots}
                                        </ul>
                                      </div>
                                    </div>
                                  </div>
                                );
                              });

                            // Apply maxHeight dynamically to all elements
                            return elements.map((el) =>
                              el
                                ? React.cloneElement(el, {
                                    style: { minHeight: `${maxHeight}px` },
                                  })
                                : null
                            );
                          })()
                        : "Nothing to Show"}
                    </div>
                    <div
                      className="number-profile"
                      id="tell"
                      style={{ backgroundColor: "#AF9763" }}
                    >
                      <a href="tel:10666" className="py-2">
                        <div className="d-flex align-items-center justify-content-center gap-5">
                          <div className="text-center d-flex justify-content-center align-items-center">
                            <FaPhoneAlt
                              size={25}
                              color="#ffffff"
                              // style={{ fontSize: "35px", color: "#fff" }}
                            />
                          </div>
                          <div className="">
                            <p>
                              <span>24*7 Hotline </span>
                              10666
                            </p>
                          </div>
                        </div>
                      </a>
                    </div>
                    <div className="row">
                      <div className="col-sm-12">
                        <button
                          type="button"
                          className="btn btn-secondary make-btn py-2 d-flex align-items-center justify-content-center gap-4"
                          style={{ backgroundColor: "#0C807D" }}
                          data-bs-toggle="offcanvas"
                          data-bs-target="#BookAppointMentParticularDoctorPopUp"
                          aria-controls="BookAppointMentParticularDoctorPopUp"
                        >
                          <FaCalendarAlt size={25} color="#ffffff" />
                          Make Appointment Online
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <h4
                  style={{
                    color: "#0C807D",
                    borderBottom: "2px solid #0C807D",
                    width: "fit-content",
                  }}
                >
                  Profile
                </h4>
              </div>
              <div className="col-lg-7 col-md-12">
                {descriptions.length > 0
                  ? descriptions
                      .filter((item) => item.visibility === 1)
                      .map((item) => (
                        <div
                          key={item.key}
                          className="mt-4 mb-2"
                          style={{
                            backgroundPosition: "center",
                            backgroundSize: "cover",
                            backgroundColor: "#fff",
                            borderRadius: "20px",
                            backgroundRepeat: "no-repeat",
                          }}
                        >
                          <div className="text-profile">
                            <p
                              className="b border-0"
                              dangerouslySetInnerHTML={{ __html: item.value }}
                            ></p>
                          </div>
                        </div>
                      ))
                  : ""}
              </div>

              {testimonials.length > 0 && (
                <div className="col-lg-5 col-md-12">
                  <div className="border-part mt-4 mb-5 shadow">
                    <div className="text-profile">
                      <h3>Testimonials</h3>
                      <div className="row mt-2">
                        <div className="col-md-12">
                          <div className="row testimonial_section">
                            <Slider {...settings}>
                              {testimonials.map((testimonial) => (
                                <div
                                  key={testimonial.id}
                                  className="post-slide testimonials-part"
                                  style={{ paddingTop: "60px", zIndex: -1 }}
                                >
                                  <div
                                    className="card d-flex flex-column shadow-sm px-2"
                                    style={{
                                      marginTop: "100px",
                                      border: "1px solid #dbdbdb",
                                      borderRadius: "10px",
                                      position: "relative",
                                    }}
                                  >
                                    <div
                                      className="d-flex justify-content-start align-items-center"
                                      style={{
                                        position: "absolute",
                                        top: isMobile ? -25 : -50,
                                        left: 0,
                                        width: "fit-content",
                                      }}
                                    >
                                      <img
                                        className="img-fluid w-50"
                                        src="/assets/images/qutation_top.png"
                                        alt=""
                                      />
                                    </div>
                                    <div
                                      className="d-flex justify-content-end align-items-center"
                                      style={{
                                        position: "absolute",
                                        bottom: isMobile ? 5 : -45,
                                        right: 0,
                                        width: "fit-content",
                                      }}
                                    >
                                      <img
                                        className="img-fluid w-50"
                                        src="/assets/images/qutation_bottom.png"
                                        alt=""
                                      />
                                    </div>
                                    <div
                                      className="text-center d-flex justify-content-center align-items-center"
                                      style={{ marginTop: "-50px" }}
                                    >
                                      <img
                                        src={
                                          testimonial.author_profile_pic
                                            ? `${IMAGE_URL}/AuthorProfileImg/${testimonial.author_profile_pic}`
                                            : "https://static.vecteezy.com/system/resources/thumbnails/003/337/584/small/default-avatar-photo-placeholder-profile-icon-vector.jpg"
                                        }
                                        alt="Author Profile"
                                        style={{
                                          height: "100px",
                                          width: "100px",
                                          borderRadius: "50%",
                                          objectFit: "cover",
                                          objectPosition: "top",
                                          border: "4px solid white",
                                          boxShadow:
                                            "0 4px 8px rgba(0, 0, 0, 0.2)",
                                        }}
                                      />
                                    </div>
                                    <div className="text-center mb-4">
                                      <p
                                        className="text-chnage"
                                        dangerouslySetInnerHTML={{
                                          __html: testimonial.testimonial_desc
                                            ? testimonial.testimonial_desc
                                                .split(" ")
                                                .slice(0, 50)
                                                .join(" ")
                                            : "",
                                        }}
                                      ></p>
                                      <p className="author-name mt-2">
                                        <strong>
                                          {testimonial.author_name}
                                        </strong>
                                      </p>
                                    </div>
                                    {testimonial.doctor_mave && (
                                      <div className="doctor-details d-flex align-items-center mb-4">
                                        <div className="me-3">
                                          <img
                                            src={`${IMAGE_URL}/DoctorProfileImg/${testimonial.doctor_mave.doctor_profile}`}
                                            alt="Doctor Profile"
                                            style={{
                                              height: "60px",
                                              width: "60px",
                                              borderRadius: "50%",
                                              objectFit: "cover",
                                            }}
                                          />
                                        </div>
                                        <div className="text-start">
                                          <h6
                                            className="mb-1"
                                            style={{ fontSize: "14px" }}
                                          >
                                            {
                                              testimonial.doctor_mave
                                                .doctor_name
                                            }
                                          </h6>
                                          <p
                                            className="mb-0"
                                            style={{ fontSize: "12px" }}
                                          >
                                            {
                                              testimonial.doctor_mave
                                                .designation
                                            }
                                          </p>
                                          <p
                                            className="mb-0"
                                            style={{ fontSize: "12px" }}
                                          >
                                            {testimonial.doctor_mave.degree}
                                          </p>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              ))}
                            </Slider>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </section>
      </div>
      {doctorData && (
        <BookAppointmentParticularDoctorPopUp
          doctorData={doctorData}
        ></BookAppointmentParticularDoctorPopUp>
      )}
      {scheduleReqData.doctorData ? (
        <ConfirmAppointmentAndRequestAppointmentParticularDoctorWithScheduleSelected
          scheduleReqData={scheduleReqData}
        ></ConfirmAppointmentAndRequestAppointmentParticularDoctorWithScheduleSelected>
      ) : null}
      <BookAppointmentPopup></BookAppointmentPopup>
    </div>
  );
};

export default DoctorProfile;



// WEBPACK FOOTER //
// ./src/component/frontend/doctorprofile/DoctorProfile.js